import React from 'react'
import ColorInput from '@app/components/molecules/TeeColorPicker/CustomColorInput'
import * as S from './TeeRow.styles'

export { TeeGrid } from './TeeRow.styles'

// The tee as it is being filled in: the two ratings are held as typed so a
// field can be emptied and retyped without turning into a zero in between.
export type TeeRowValue = {
  title: string
  color: string
  courseRating: string
  slopeRating: string
}

const isFilled = (value: string) => value.trim() !== '' && Number(value) > 0

export const isTeeRowComplete = (row: TeeRowValue) =>
  row.title.trim() !== '' &&
  isFilled(row.courseRating) &&
  isFilled(row.slopeRating)

export const TeeRowHeader = () => (
  <>
    <S.ColumnLabel>Color</S.ColumnLabel>
    <S.ColumnLabel>Tee name</S.ColumnLabel>
    <S.ColumnLabel>Course rating</S.ColumnLabel>
    <S.ColumnLabel>Slope rating</S.ColumnLabel>
  </>
)

type Props = {
  // What the fields of this row are called to a screen reader, such as
  // "Tee 2" in a set or just "Tee" on its own.
  label: string
  value: TeeRowValue
  onChange: (update: Partial<TeeRowValue>) => void
  // Set once adding has been tried, so a row does not open marked red.
  showErrors?: boolean
}

export const TeeRow: React.FC<Props> = ({
  label,
  value,
  onChange,
  showErrors,
}) => (
  <>
    <S.ColorCell>
      <ColorInput
        value={value.color}
        label={`Color for ${label.toLowerCase()}`}
        onChange={(color) => onChange({ color })}
      />
    </S.ColorCell>
    <S.NameInput
      value={value.title}
      aria-label={`${label} name`}
      hasError={showErrors && value.title.trim() === ''}
      onChange={({ target }) => onChange({ title: target.value })}
    />
    <S.NumberInput
      type="number"
      step="0.1"
      value={value.courseRating}
      aria-label={`${label} course rating`}
      hasError={showErrors && !isFilled(value.courseRating)}
      onChange={({ target }) => onChange({ courseRating: target.value })}
    />
    <S.NumberInput
      type="number"
      value={value.slopeRating}
      aria-label={`${label} slope rating`}
      hasError={showErrors && !isFilled(value.slopeRating)}
      onChange={({ target }) => onChange({ slopeRating: target.value })}
    />
  </>
)

export default TeeRow
